import React, { useEffect, useRef, useState } from 'react';
import * as rsuite from 'rsuite';

import Layout from '../../Layout/PrivateLayout';
import * as General from '../General/General';
import { trackPromise } from 'react-promise-tracker';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import * as BiIcon from "react-icons/bi";
import {Modal} from "react-bootstrap";
import Delete from '../Delete/Delete.js';
import Drp_ProductGroup from '../ProductGroup/Drp_Group';
import Drp_ProductParentGroup from '../ProductGroup/Drp_Group';
import Auto_Product from '../Product/Auto_Product';
import Drp_StoreRoom from '../StoreRoom/Drp_StoreRoom_Simple';
import moment from 'moment-jalaali';
import DatePicker from 'react-datepicker2';
import PN from "persian-number";



const BuyOrderIndex = () => {

    //#region Const
    const toaster = rsuite.useToaster();
    const rowKey = 'Id';
    let navigate = useNavigate();
    const DeleteRef = useRef()
    const ProductRef = useRef()
    const GroupRef = useRef()
    const ParentGroupRef = useRef()
    const [List, setList] = useState([]);
    const [Id, setId] = useState(General.GuidEmpty());
    const [ItemList, setItemList] = useState([]);
    const [RecieptList, setRecieptList] = useState([]);
    const [FiscalYearId, setFiscalYearId] = useState(localStorage.getItem("FiscalYearId"));
    const [GroupId, setGroupId] = useState("-1");
    const [GroupParentId, setGroupParentId] = useState("-1");
    const [ProductTitle, setProductTitle] = useState('');
    const [ProductId, setProductId] = useState(General.GuidEmpty());
    const [Code, setCode] = useState("");
    const [TitleCode, setTitleCode] = useState("");
    const [IsConfirm, setIsConfirm] = useState(-1);
    const [StoreRoomId, setStoreRoomId] = useState(-1);
    const [BeginDate, setBeginDate] = useState(moment(new Date()).add("Day", -30));
    const [EndDate, setEndDate] = useState(moment(new Date()));
    const [RecieptDate, setRecieptDate] = useState(moment(new Date()));
    //#region Tabe Setting

    const [expandedRowKeys, setExpandedRowKeys] = React.useState([0]);
    const [ShowModal, setShowModal] = React.useState(false);
    const [ShowRecieptModal, setShowRecieptModal] = React.useState(false);
    const [sortColumn, setSortColumn] = React.useState();
    const [sortType, setSortType] = React.useState();
    const [loading, setLoading] = React.useState(false)
    //#endregion

    //#region Check All Item
    let checked = false;
    let indeterminate = false;

    if ([...ItemList].filter(item => item.isSelected == 1).length === ItemList.length) {
        checked = true;
    } else if ([...ItemList].filter(item => item.isSelected == 1).length === 0) {
        checked = false;
    } else if ([...ItemList].filter(item => item.isSelected == 1).length > 0 && [...ItemList].filter(item => item.isSelected == 1).length < ItemList.length) {
        indeterminate = true;
    }
    //#endregion

    //#endregion

    const handleExpanded = (rowData) => {
        let open = false;
        const nextExpandedRowKeys = [];
        expandedRowKeys.forEach(key => {

            if (key === rowData[rowKey]) {
                open = true;
            } else if (key != undefined) {
                nextExpandedRowKeys.push(key);
            }
        });

        if (!open) {
            nextExpandedRowKeys.push(rowData[rowKey]);
        }

        setExpandedRowKeys(nextExpandedRowKeys);
    };
    const handleSortColumn = (sortColumn, sortType) => {
        setLoading(true);
        setTimeout(() => {
            setLoading(false);
            setSortColumn(sortColumn);
            setSortType(sortType);
        }, 500);
    };

    const Product_Select = (e) => {
        setProductId(e.split("|")[0])
        setProductTitle(e.split("|")[1])
    }

    const Product_Change = (e) => {
        setProductId(General.GuidEmpty())
        if (e.split("|").length > 1) {
            setProductTitle(e.split("|")[1]);
            return;
        }
        setProductTitle(e);
        ProductRef.current.Bind(GroupParentId, GroupId, e)

    }

    const BeginDate_Change = e => {
        var m = moment(e.format()).format('jYYYY/jMM/jDD');
        setBeginDate(moment(m, 'jYYYY/jMM/jDD'));
    }

    const EndDate_Change = e => {
        var m = moment(e.format()).format('jYYYY/jMM/jDD');
        setEndDate(moment(m, 'jYYYY/jMM/jDD'));
    }

    const Parent_Change = (value) => {
        setGroupParentId(value);
        setProductId(General.GuidEmpty());
        setProductTitle("");
        setGroupId("-1");
        GroupRef.current.BindGroupByParentId(0, value);
        ProductRef.current.Bind(value, -1, '')
    }

    const Group_Change = (value) => {
        setGroupId(value);
        setProductId(General.GuidEmpty());
        setProductTitle("");
        ProductRef.current.Bind(GroupParentId, value, '')
    }

    //#region Methods


    const Search = () => {
        trackPromise(
            fetch(General.ApiRoute() + '/BuyOrder/SearchHeader', {
                method: 'Get',
                headers: {
                    'ApiKey': General.APIKey(),
                    'BeginDate': BeginDate != null ? moment(BeginDate.format()).format("jYYYY/jMM/jDD") : "",
                    'EndDate': EndDate != null ? moment(EndDate.format()).format("jYYYY/jMM/jDD") : "",
                    'IsConfirm': IsConfirm,
                    'ProductId': ProductId,
                    'GroupId': GroupId,
                    'GroupParentId': GroupParentId,
                    'FiscalYearId': FiscalYearId,
                    'Code': Code,
                },
                credentials: 'include'
            })
                .then(res => res.json())
                .then(result => {
                    var tmp = []
                    for (var i = 0; i < result.length; i++) {
                        tmp.push({
                            row: i + 1,
                            Id: result[i].id,
                            Price: PN.sliceNumber(result[i].price),
                            SupplierFullName: result[i].supplierFullName,
                            SupplierPhone: result[i].supplierPhone,
                            InsertDateTime: result[i].insertDate + " " + result[i].insertTime,
                            Code: result[i].code,
                            InsertUser: result[i].insertUser,
                            IsConfirm: result[i].isConfirm,
                            children: result[i].children,

                        })
                    }
                    setList(tmp)
                })
        )
    }



    const UpdateIsConfirm = () => {
        if (ItemList.filter(x => x.isSelected == 1).length == 0) {
            toaster.push(General.ShowMessage('error', General.ErrorMessage(" آیتم های  مورد نظر ر انتخاب نمایید")), 'topCenter')
            return;
        }

        if (ItemList.filter(x => x.isSelected == 1 &&
            (x.storeRoomId == -1 || x.StoreRoomId == 0 || x.recieptCount == 0 || x.recieptDate == "" || x.recieptDate == null)).length > 0) {
            toaster.push(General.ShowMessage('error', General.ErrorMessage("انبار، تعداد، تاریخ آیتم های انتخابی را وارد نمایید")), 'topCenter')
            return;
        }


        var RequestOptions = {
            data: {
                "Id": Id,
                "Code": TitleCode,
                "Children": ItemList
            },
            url: General.ApiRoute() + "/BuyOrder/UpdateIsConfirm",
            method: "post",
            withCredentials: true,

            headers: {
                'ApiKey': General.APIKey(),
                'Content-Type': 'application/json',
                // 'StoreRoomId': StoreRoomId,
                // 'RecieptDate': moment(RecieptDate.format()).format("jYYYY/jMM/jDD")
            }
        }


        trackPromise(
            axios(RequestOptions)
                .then(function (result) {
                    if (result.data.includes("OK")) {
                        var comment = result.data.split("|")[1];
                        toaster.push(General.ShowMessage('success', General.SuccessMessage("ذخیزه شده است، شماره رسید :" + comment)), 'topCenter')
                        Search();
                        setShowModal(false);

                    }
                    else {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage(result.data)), 'topCenter')

                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')

                })
        )
    }

    const ShowConfirm = (id, code, itemList, insertDate) => {


        setShowModal(true);
        setId(id);
        setTitleCode(code);
        for (let index = 0; index < itemList.length; index++) {
            itemList[index].row = index + 1;
        }

        setItemList(itemList);

        // setRecieptDate(moment(insertDate, 'jYYYY/jMM/jDD'))
    }

    const Item_CheckAll = (checked) => {
        var temp = [...ItemList];
        checked ? temp.filter(x => x.count - x.returnCount != 0).map(item => item.isSelected = 1) :
            temp.filter(x => x.count - x.returnCount != 0).map(item => item.isSelected = 0);
        setItemList(temp);
        // setCheckedKeys(keys);
    };

    const Item_Check = (checked, id) => {
        var temp = [...ItemList];
        var index = temp.findIndex(x => x.id == id);
        if (index != -1) {
            temp[index].isSelected = checked ? 1 : 0;
        }
        setItemList(temp);
    };

    const Item_Change = (value, id, datatype) => {
        var temp = [...ItemList];
        var index = temp.findIndex(x => x.id == id);
        if (index != -1) {
            if (datatype == "RecieptCount") {
                if (value > temp[index].count - temp[index].returnCount) {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage("تعداد محصول در رسید نمی تواند بیشتر از محصول رسید نشده باشد")), 'topCenter')
                }
                else {
                    temp[index].recieptCount = value * 1;
                }
            }
            if (datatype == "StoreRoom") {
                temp[index].storeRoomId = value;
            }
            if (datatype == "RecieptDate") {

                if (value < moment(temp[index].insertDate, 'jYYYY/jMM/jDD')) {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage("تاریخ رسید نمی تواند قبل از فاکتور خرید باشد")), 'topCenter')
                }
                else {
                    var m = moment(value.format()).format('jYYYY/jMM/jDD');
                    temp[index].recieptDate = m;
                }

            }
        }
        setItemList(temp);
    };

    const ShowReciept = (id, code) => {
        setShowRecieptModal(true);
        setTitleCode(code);
        trackPromise(
            fetch(General.ApiRoute() + '/StoreRoomReciept/GetByHeaderRefId', {
                method: 'Get',
                headers: {
                    'ApiKey': General.APIKey(),
                    'HeaderRefId': id
                },
                credentials: 'include'
            })
                .then(res => res.json())
                .then(result => {
                    var tmp = []
                    for (var i = 0; i < result.length; i++) {
                        tmp.push({
                            row: i + 1,
                            Product: result[i].product,
                            ProductIdentityNo: result[i].productIdentityNo,
                            Count: result[i].count,
                            Price: PN.sliceNumber(result[i].price),
                            Tax: PN.sliceNumber(result[i].tax),
                            TotalPrice: PN.sliceNumber(result[i].totalPrice),
                            DiscountPrice: PN.sliceNumber(result[i].discountPrice),
                            // BeforPhysicalCount: result[i].beforPhysicalCount,
                            // BeforSaleCount: result[i].beforSaleCount,
                            // NextPhysicalCount: result[i].nextPhysicalCount,
                            // NextSaleCount: result[i].nextSaleCount,
                            StoreRoom: result[i].storeRoom,
                            InsertDateTime: result[i].insertDate + " / " + result[i].insertTime,
                            // ConfirmDateTime: result[i].confirmDate + " " + result[i].confirmTime,
                            Code: result[i].headerCode,
                            IsConfirm: result[i].confirmId != General.GuidEmpty() ? "تایید شده" : "تایید نشده",

                        })
                    }
                    setRecieptList(tmp)
                })
        )
    }

    const ShowDelete = (id, code) => {
        DeleteRef.current.Get(16, id, code);
    }

    const ShowEdit = (id) => {
        var myHeaders = new Headers();
        myHeaders.append("ApiKey", General.APIKey());
        myHeaders.append("Page", 16);
        myHeaders.append("Operation", 3);

        var requestOptions = {
            method: "Get",
            headers: myHeaders,
            credentials: 'include'

        };
        trackPromise(
            fetch(General.ApiRoute() + "/Common/CheckPermission", requestOptions)
                .then(response => response.text())
                .then(result => {
                    if (result.toString() != "OK") {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage("AccessDenied")), 'topCenter')

                    }
                    else {
                        navigate("/InsertBuyOrder")
                        localStorage.setItem("BuyOrderHeaderId", id)
                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')
                })
        )


    }
    const ShowPrint = (id) => {
        navigate("/PrintBuyOrder")
        localStorage.setItem("BackPage", "BuyOrder");
        localStorage.setItem("BuyOrderHeaderId", id)
    }

    const ShowNew = () => {
        var myHeaders = new Headers();
        myHeaders.append("ApiKey", General.APIKey());
        myHeaders.append("Page", 16);
        myHeaders.append("Operation", 1);

        var requestOptions = {
            method: "Get",
            headers: myHeaders,
            credentials: 'include'

        };
        trackPromise(
            fetch(General.ApiRoute() + "/Common/CheckPermission", requestOptions)
                .then(response => response.text())
                .then(result => {
                    if (result.toString() != "OK") {
                        toaster.push(General.ShowMessage('error', General.ErrorMessage("AccessDenied")), 'topCenter')
                    }
                    else {
                        navigate("/InsertBuyOrder")
                        localStorage.setItem("BuyOrderHeaderId", General.GuidEmpty())

                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')
                })
        )
    }


    const CheckPermission = () => {
        var myHeaders = new Headers();
        myHeaders.append("ApiKey", General.APIKey());
        myHeaders.append("Page", 16);
        myHeaders.append("Operation", 0);

        var requestOptions = {
            method: "Get",
            headers: myHeaders,
            credentials: 'include'

        };
        trackPromise(
            fetch(General.ApiRoute() + "/Common/CheckPermission", requestOptions)
                .then(response => response.text())
                .then(result => {
                    if (result.toString() != "OK") {
                        navigate("/AccessDenied");
                    }
                    else {
                        Search();
                        ParentGroupRef.current.BindGroupByParentId(-1, 0);
                    }
                }).catch((error) => {
                    toaster.push(General.ShowMessage('error', General.ErrorMessage(error)), 'topCenter')
                })
        )
    }

    const handelKeyDown = (e, row) => {
        if (e.key == "Enter") {
            Search();
        }
        if (e.shiftKey && e.code === "KeyN") {
            ShowNew();
        }

    }

    useEffect(() => {
        CheckPermission();
        document.title = " فاکتور خرید";
        const inputElement = document.querySelector('.FocusItem');
        if (inputElement) {
            inputElement.focus();
        }
    }, [])
    //#endregion


    return (

        <Layout title="فاکتور خرید ">


            <div className="h-100 p-1" onKeyDown={handelKeyDown}>
                <rsuite.Panel className="bg-white ">
                    <rsuite.Grid fluid>
                        <rsuite.Row>

                            <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24} className="text-left" >
                                <rsuite.Button appearance="primary" size="xs" className="m-1" onClick={Search}>  جستجو</rsuite.Button>
                                <rsuite.Button appearance="primary" color="green" size="xs" className="m-1" onClick={ShowNew}>  جـــدید</rsuite.Button>

                            </rsuite.Col>
                        </rsuite.Row>
                    </rsuite.Grid>
                    <hr />
                    <rsuite.Row className='p-1'>

                        <rsuite.Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                            <label>شماره فاکتور</label>
                            <rsuite.Input className='FocusItem' value={Code} onChange={(e) => setCode(e)} />
                        </rsuite.Col>

                        <rsuite.Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                            <label> از تاریخ </label>
                            <DatePicker className="rs-input" isGregorian={false} timePicker={false} icon={BiIcon.BiCalendar} value={BeginDate} onChange={BeginDate_Change} />

                        </rsuite.Col>
                        <rsuite.Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                            <label>تا تاریخ </label>
                            <DatePicker className="rs-input" isGregorian={false} timePicker={false} icon={BiIcon.BiCalendar} value={EndDate} onChange={EndDate_Change} />
                        </rsuite.Col>
                        <rsuite.Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                            <label> وضعیت تبدیل به رسید انبار</label>
                            <select className="rs-input" onChange={(e) => setIsConfirm(e.target.value)} value={IsConfirm}>
                                <option value="-1">انتخاب نمایید</option>
                                <option value="0">تبدیل نشده </option>
                                <option value="1">تمام آیتم ها تبدیل شده </option>
                                <option value="2">برخی آیتم ها تبدیل شده </option>


                            </select>
                        </rsuite.Col>
                    </rsuite.Row>
                    <rsuite.Row className='p-1'>


                        <rsuite.Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                            <label>گروه   </label>
                            <Drp_ProductParentGroup className="rs-input" value={GroupParentId} onChange={Parent_Change} ref={ParentGroupRef} />
                        </rsuite.Col>
                        <rsuite.Col xxl={6} xl={6} lg={6} md={6} sm={12} xs={12}>
                            <label>زیر گروه   </label>
                            <Drp_ProductGroup className="rs-input" value={GroupId} onChange={Group_Change} ref={GroupRef} />
                        </rsuite.Col>

                        <rsuite.Col xxl={12} xl={12} lg={12} md={12} sm={24} xs={24}>
                            <label> محصول   </label>
                            <Auto_Product className="rs-input" value={ProductTitle} onChange={Product_Change} onSelect={Product_Select} ref={ProductRef} />
                        </rsuite.Col>




                    </rsuite.Row>

                    <div className="h-90 p-1">
                        <div className="h-100-y">

                            <rsuite.Panel className="bg-white mt-2">

                                <rsuite.Table
                                    rowKey={rowKey}
                                    // rowExpandedHeight={210}
                                    rowExpandedHeight={rowData => {
                                        return (
                                            rowData.children.length * 70)
                                    }}

                                    height={500}
                                    data={List}
                                    expandedRowKeys={expandedRowKeys}
                                    loading={loading}
                                    renderRowExpanded={rowData => {
                                        return (
                                            <div>
                                                <rsuite.Table
                                                    data={rowData.children}
                                                    loading={loading}
                                                    autoHeight={true}
                                                    className='text-black-50'
                                                >
                                                    <rsuite.Table.Column width={50} align="center"  >
                                                        <rsuite.Table.HeaderCell>#</rsuite.Table.HeaderCell>
                                                        <rsuite.Table.Cell >
                                                        </rsuite.Table.Cell>
                                                    </rsuite.Table.Column>


                                                    <rsuite.Table.Column width={100} flexGrow={1} fullText resizable>
                                                        <rsuite.Table.HeaderCell>محصول </rsuite.Table.HeaderCell>
                                                        <rsuite.Table.Cell dataKey='product' />
                                                    </rsuite.Table.Column>


                                                    <rsuite.Table.Column width={100} >
                                                        <rsuite.Table.HeaderCell>تعداد</rsuite.Table.HeaderCell>
                                                        <rsuite.Table.Cell dataKey='count' />
                                                    </rsuite.Table.Column>
                                                    <rsuite.Table.Column flexGrow={1} >
                                                        <rsuite.Table.HeaderCell>قیمت واحد (ریال)</rsuite.Table.HeaderCell>
                                                        <rsuite.Table.Cell>
                                                            {(rowData) => {
                                                                return (
                                                                    <>
                                                                        {PN.sliceNumber(rowData.price)}
                                                                    </>

                                                                )
                                                            }}
                                                        </rsuite.Table.Cell>
                                                    </rsuite.Table.Column>
                                                    <rsuite.Table.Column width={100} >
                                                        <rsuite.Table.HeaderCell>تخفیف (%)</rsuite.Table.HeaderCell>
                                                        <rsuite.Table.Cell dataKey='discountPercent' />
                                                    </rsuite.Table.Column>
                                                    <rsuite.Table.Column width={150} >
                                                        <rsuite.Table.HeaderCell>تخفیف واحد (ریال)</rsuite.Table.HeaderCell>
                                                        <rsuite.Table.Cell>
                                                            {(rowData) => {
                                                                return (
                                                                    <>
                                                                        {PN.sliceNumber(rowData.discountPrice)}
                                                                    </>

                                                                )
                                                            }}
                                                        </rsuite.Table.Cell>
                                                    </rsuite.Table.Column>
                                                    <rsuite.Table.Column width={150} >
                                                        <rsuite.Table.HeaderCell>مالیات واحد (ریال)</rsuite.Table.HeaderCell>
                                                        <rsuite.Table.Cell>
                                                            {(rowData) => {
                                                                return (
                                                                    <>
                                                                        {PN.sliceNumber(rowData.tax)}
                                                                    </>

                                                                )
                                                            }}
                                                        </rsuite.Table.Cell>
                                                    </rsuite.Table.Column>
                                                    <rsuite.Table.Column width={150} >
                                                        <rsuite.Table.HeaderCell>قیمت کل (ریال)</rsuite.Table.HeaderCell>
                                                        <rsuite.Table.Cell>
                                                            {(rowData) => {
                                                                return (
                                                                    <>
                                                                        {PN.sliceNumber(rowData.totalPrice)}
                                                                    </>

                                                                )
                                                            }}
                                                        </rsuite.Table.Cell>
                                                    </rsuite.Table.Column>
                                                    <rsuite.Table.Column width={100} >
                                                        <rsuite.Table.HeaderCell>تعداد رسید شده</rsuite.Table.HeaderCell>
                                                        <rsuite.Table.Cell dataKey='returnCount' />
                                                    </rsuite.Table.Column>
                                                </rsuite.Table>
                                            </div>
                                        );
                                    }}

                                >

                                    <rsuite.Table.Column className="w-10p" align="center" fixed >
                                        <rsuite.Table.HeaderCell>#</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell>
                                            {(rowData) => {
                                                return <>
                                                    {expandedRowKeys.some(key => key === rowData[rowKey]) ? (
                                                        <BiIcon.BiMinusCircle size='12px' color='red' appearance="subtle"
                                                            onClick={() => {
                                                                handleExpanded(rowData);
                                                            }} />
                                                    ) : (
                                                        <BiIcon.BiPlusCircle size='12px' color='green' appearance="subtle"
                                                            onClick={() => {
                                                                handleExpanded(rowData);
                                                            }} />
                                                    )}

                                                    {/* <ExpandCell dataKey="id" expandedRowKeys={expandedRowKeys} onChange={handleExpanded} /> */}
                                                    &nbsp;&nbsp; {rowData.row}
                                                </>


                                            }}

                                        </rsuite.Table.Cell>
                                    </rsuite.Table.Column>

                                    <rsuite.Table.Column fullText flexGrow={1} resizable>
                                        <rsuite.Table.HeaderCell>شماره فاکتور</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey="Code" />

                                    </rsuite.Table.Column>
                                    <rsuite.Table.Column fullText flexGrow={1} resizable>
                                        <rsuite.Table.HeaderCell>تامین کننده</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey="SupplierFullName" />
                                    </rsuite.Table.Column>
                                    <rsuite.Table.Column fullText flexGrow={1} resizable>
                                        <rsuite.Table.HeaderCell>تاریخ</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey="InsertDateTime" />
                                    </rsuite.Table.Column>
                                    <rsuite.Table.Column fullText flexGrow={1} resizable>
                                        <rsuite.Table.HeaderCell>قیمت</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey="Price" />
                                    </rsuite.Table.Column>
                                    <rsuite.Table.Column fullText flexGrow={1} resizable>
                                        <rsuite.Table.HeaderCell>کاربر</rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell dataKey="InsertUser" />
                                    </rsuite.Table.Column>
                                    <rsuite.Table.Column fullText flexGrow={1} resizable>
                                        <rsuite.Table.HeaderCell>وضعیت   </rsuite.Table.HeaderCell>
                                        <rsuite.Table.Cell>
                                            {(rowData) => {
                                                return <>

                                                    {rowData.IsConfirm == 0 ?

                                                        <>رسید نشده</>
                                                        : rowData.IsConfirm == 1 ?
                                                            <>تمام آیتم ها رسید شده </>
                                                            :
                                                            <>برخی آیتم ها رسید شده </>

                                                    }
                                                </>


                                            }}

                                        </rsuite.Table.Cell>
                                    </rsuite.Table.Column>


                                    <rsuite.Table.Column fixed="right" width={60} >
                                        <rsuite.Table.HeaderCell></rsuite.Table.HeaderCell>

                                        <rsuite.Table.Cell>
                                            {(rowData) => {
                                                return <>
                                                    <rsuite.Whisper placement="autoVerticalStart" trigger="click" speaker={
                                                        <rsuite.Popover full className='PopoverMenu'>
                                                            <rsuite.Dropdown.Menu  >
                                                                <rsuite.Dropdown.Item className={rowData.IsConfirm != 1 ? '' : "hide"} onClick={() => ShowEdit(rowData.Id)}>ویرایش</rsuite.Dropdown.Item>
                                                                <rsuite.Dropdown.Item className={rowData.IsConfirm == 0 ? '' : "hide"} onClick={() => ShowDelete(rowData.Id, rowData.Code)}>حذف</rsuite.Dropdown.Item>
                                                                <rsuite.Dropdown.Item className={rowData.IsConfirm != 0 ? '' : "hide"} onClick={() => ShowReciept(rowData.Id, rowData.Code, rowData.children)}>نمایش رسید ورود به انبار</rsuite.Dropdown.Item>
                                                                <rsuite.Dropdown.Item className={rowData.IsConfirm != 1 ? '' : "hide"} onClick={() => ShowConfirm(rowData.Id, rowData.Code, rowData.children, rowData.InsertDate)}>ثبت رسید ورود به انبار</rsuite.Dropdown.Item>
                                                                <rsuite.Dropdown.Item onClick={() => ShowPrint(rowData.Id)}>چاپ</rsuite.Dropdown.Item>

                                                            </rsuite.Dropdown.Menu>
                                                        </rsuite.Popover>
                                                    }>
                                                        <rsuite.IconButton appearance="subtle" icon={<BiIcon.BiDotsHorizontalRounded />} />
                                                    </rsuite.Whisper>
                                                </>
                                            }}
                                        </rsuite.Table.Cell>

                                    </rsuite.Table.Column>
                                </rsuite.Table>

                            </rsuite.Panel>

                        </div>
                    </div>
                    <rsuite.Row>
                        <rsuite.Col xxl={24} xl={24} lg={24} md={24} sm={24} xs={24}>
                            <rsuite.Divider></rsuite.Divider>
                            <small><b> Shift+N :</b> جدید<b>| Enter :</b> جستجو </small>
                        </rsuite.Col>
                    </rsuite.Row>
                </rsuite.Panel >
            </div >

            <Modal show={ShowRecieptModal} onHide={() => setShowRecieptModal(false)} fullscreen scrollable >
                <Modal.Header >
                    <Modal.Title className='fs-5'><b> {TitleCode} </b>  </Modal.Title>
                </Modal.Header>
                <Modal.Body >
                    <rsuite.Grid fluid>
                        <rsuite.Table
                            height={420}
                            data={RecieptList.sort((a, b) => {
                                let x = a[sortColumn];
                                let y = b[sortColumn];
                                if (typeof x === 'string') {
                                    x = x.charCodeAt();
                                }
                                if (typeof y === 'string') {
                                    y = y.charCodeAt();
                                }
                                if (sortType === 'asc') {
                                    return x - y;
                                } else {
                                    return y - x;
                                }
                            })}
                            sortColumn={sortColumn}
                            sortType={sortType}
                            onSortColumn={handleSortColumn}
                            loading={loading}

                        >
                            <rsuite.Table.Column width={50} align="center" fixed sortable>
                                <rsuite.Table.HeaderCell>#</rsuite.Table.HeaderCell>
                                <rsuite.Table.Cell dataKey="row" />
                            </rsuite.Table.Column>

                            <rsuite.Table.Column width={100} fullText sortable resizable>
                                <rsuite.Table.HeaderCell>شماره رسید</rsuite.Table.HeaderCell>
                                <rsuite.Table.Cell dataKey="Code" />
                            </rsuite.Table.Column>
                            <rsuite.Table.Column width={100} fullText sortable resizable>
                                <rsuite.Table.HeaderCell>وضعیت رسید</rsuite.Table.HeaderCell>
                                <rsuite.Table.Cell dataKey="IsConfirm" />
                            </rsuite.Table.Column>
                            <rsuite.Table.Column width={150} fullText sortable resizable>
                                <rsuite.Table.HeaderCell> تاریخ / ساعت رسید</rsuite.Table.HeaderCell>
                                <rsuite.Table.Cell dataKey="InsertDateTime" />
                            </rsuite.Table.Column>
                            <rsuite.Table.Column width={100} fullText sortable resizable>
                                <rsuite.Table.HeaderCell>انبار</rsuite.Table.HeaderCell>
                                <rsuite.Table.Cell dataKey="StoreRoom" />
                            </rsuite.Table.Column>

                            <rsuite.Table.Column flexGrow={1} fullText sortable resizable>
                                <rsuite.Table.HeaderCell>محصول</rsuite.Table.HeaderCell>
                                <rsuite.Table.Cell dataKey="Product" />
                            </rsuite.Table.Column>

                            <rsuite.Table.Column width={80} fullText sortable resizable>
                                <rsuite.Table.HeaderCell> تعداد</rsuite.Table.HeaderCell>
                                <rsuite.Table.Cell dataKey="Count" />
                            </rsuite.Table.Column>
                            <rsuite.Table.Column width={150} fullText sortable resizable>
                                <rsuite.Table.HeaderCell> قیمت واحد (ریال)</rsuite.Table.HeaderCell>
                                <rsuite.Table.Cell dataKey="Price" />
                            </rsuite.Table.Column>
                            <rsuite.Table.Column width={150} fullText sortable resizable>
                                <rsuite.Table.HeaderCell> تخفیف واحد (ریال)</rsuite.Table.HeaderCell>
                                <rsuite.Table.Cell dataKey="DiscountPrice" />
                            </rsuite.Table.Column>
                            <rsuite.Table.Column width={150} fullText sortable resizable>
                                <rsuite.Table.HeaderCell> مالیات واحد (ریال)</rsuite.Table.HeaderCell>
                                <rsuite.Table.Cell dataKey="Tax" />
                            </rsuite.Table.Column>
                            <rsuite.Table.Column width={150} fullText sortable resizable>
                                <rsuite.Table.HeaderCell> قیمت کل (ریال)</rsuite.Table.HeaderCell>
                                <rsuite.Table.Cell dataKey="TotalPrice" />
                            </rsuite.Table.Column>




                        </rsuite.Table>

                    </rsuite.Grid>
                </Modal.Body>
                <Modal.Footer>

                    <rsuite.Button appearance="subtle" onClick={() => setShowRecieptModal(false)}>
                        بستن
                    </rsuite.Button>

                </Modal.Footer>
            </Modal>

            <Modal show={ShowModal} fullscreen onHide={() => setShowModal(false)} scrollable >
                <Modal.Header >
                    <Modal.Title className='fs-5'><b> {TitleCode} </b>  </Modal.Title>
                </Modal.Header>
                <Modal.Body >
                    <rsuite.Grid fluid>
                        <rsuite.Table
                            height={600}
                            data={ItemList}
                            loading={loading}
                            datatype='id'

                        >

                            <rsuite.Table.Column width={50} align="center" fixed sortable>
                                <rsuite.Table.HeaderCell>#</rsuite.Table.HeaderCell>
                                <rsuite.Table.Cell dataKey='row' />
                            </rsuite.Table.Column>
                            <rsuite.Table.Column width={50} align="center" fixed>

                                <rsuite.Table.HeaderCell>
                                    <rsuite.Checkbox
                                        inline
                                        checked={checked}
                                        indeterminate={indeterminate}
                                        onChange={(e, checked) => Item_CheckAll(checked)}
                                    />
                                </rsuite.Table.HeaderCell>
                                <rsuite.Table.Cell>
                                    {(rowData) => {
                                        return <>
                                            <rsuite.Checkbox
                                                value={rowData.isSelected}
                                                inline
                                                onChange={(e, checked) => Item_Check(checked, rowData.id)}
                                                checked={rowData.isSelected}
                                                disabled={rowData.count - rowData.returnCount == 0 ? true : false}
                                            />
                                        </>
                                    }}

                                </rsuite.Table.Cell>
                            </rsuite.Table.Column>
                            <rsuite.Table.Column width={150} fullText sortable resizable>
                                <rsuite.Table.HeaderCell> تاریخ رسید</rsuite.Table.HeaderCell>
                                <rsuite.Table.Cell>
                                    {(rowData) => {
                                        return <>
                                            <DatePicker className="rs-input" isGregorian={false} timePicker={false}
                                                disabled={rowData.count - rowData.returnCount == 0 ? true : false}

                                                icon={BiIcon.BiCalendar} value={moment(rowData.recieptDate, 'jYYYY/jMM/jDD')} onChange={value => {
                                                    Item_Change?.(value, rowData.id, "RecieptDate");
                                                }} />

                                        </>
                                    }}

                                </rsuite.Table.Cell>
                            </rsuite.Table.Column>
                            <rsuite.Table.Column width={150} fullText sortable resizable>
                                <rsuite.Table.HeaderCell>انبار</rsuite.Table.HeaderCell>
                                <rsuite.Table.Cell>
                                    {(rowData) => {
                                        return <>
                                            <Drp_StoreRoom className="rs-input" value={rowData.storeRoomId}
                                                disabled={rowData.count - rowData.returnCount == 0 ? true : false}

                                                onChange={value => {
                                                    Item_Change?.(value, rowData.id, "StoreRoom");
                                                }} />

                                        </>
                                    }}
                                </rsuite.Table.Cell>
                            </rsuite.Table.Column>

                            <rsuite.Table.Column flexGrow={1} fullText sortable resizable>
                                <rsuite.Table.HeaderCell>محصول</rsuite.Table.HeaderCell>
                                <rsuite.Table.Cell dataKey="product" />
                            </rsuite.Table.Column>

                            <rsuite.Table.Column width={100} fullText sortable resizable>
                                <rsuite.Table.HeaderCell> تعداد کل</rsuite.Table.HeaderCell>
                                <rsuite.Table.Cell dataKey="count" />
                            </rsuite.Table.Column>
                            <rsuite.Table.Column width={150} fullText sortable resizable>
                                <rsuite.Table.HeaderCell> تعداد در رسید </rsuite.Table.HeaderCell>
                                <rsuite.Table.Cell >
                                    {(rowData) => {
                                        return <>

                                            <rsuite.Badge color='green' size='10' content={'باقیمانده : ' + (rowData.count - rowData.returnCount)}>
                                                <rsuite.Input className="rs-input" value={rowData.recieptCount}
                                                    disabled={rowData.count - rowData.returnCount == 0 ? true : false}

                                                    onChange={value => {
                                                        Item_Change?.(value, rowData.id, "RecieptCount");
                                                    }} />
                                                {/* <rsuite.Text className='Font10 float-start' as='sub'>{'باقیمانده : ' + (rowData.count - rowData.returnCount)}</rsuite.Text> */}

                                            </rsuite.Badge>
                                        </>
                                    }}
                                </rsuite.Table.Cell >
                            </rsuite.Table.Column>
                            <rsuite.Table.Column width={150} fullText sortable resizable>
                                <rsuite.Table.HeaderCell> قیمت واحد (ریال)</rsuite.Table.HeaderCell>
                                <rsuite.Table.Cell>
                                    {(rowData) => {
                                        return <>
                                            {PN.sliceNumber(rowData.price)}
                                        </>
                                    }}
                                </rsuite.Table.Cell>
                            </rsuite.Table.Column>
                            <rsuite.Table.Column width={150} fullText sortable resizable>
                                <rsuite.Table.HeaderCell> قیمت با احتصاب تخفیف و مالیات واحد (ریال)</rsuite.Table.HeaderCell>
                                <rsuite.Table.Cell>
                                    {(rowData) => {
                                        return <>
                                            {PN.sliceNumber(rowData.price + rowData.tax - rowData.headerDiscount - rowData.discountPrice)}
                                        </>
                                    }}
                                </rsuite.Table.Cell>
                            </rsuite.Table.Column>
                            <rsuite.Table.Column width={150} fullText sortable resizable>
                                <rsuite.Table.HeaderCell> قیمت کل رسید شده (ریال)</rsuite.Table.HeaderCell>
                                <rsuite.Table.Cell>
                                    {(rowData) => {
                                        return <>
                                            {PN.sliceNumber((rowData.price + rowData.tax - rowData.headerDiscount - rowData.discountPrice) * rowData.recieptCount)}
                                        </>
                                    }}
                                </rsuite.Table.Cell>
                            </rsuite.Table.Column>

                        </rsuite.Table>

                    </rsuite.Grid>
                </Modal.Body>
                <Modal.Footer>

                    <rsuite.Button appearance="primary" color='green' size='sm' onClick={UpdateIsConfirm}>
                        ثبت
                    </rsuite.Button>
                    <rsuite.Button appearance="subtle" onClick={() => setShowModal(false)}>
                        بستن
                    </rsuite.Button>

                </Modal.Footer>
            </Modal>

            <Delete ref={DeleteRef} onSubmit={Search} />
        </Layout >


    )
}

export default BuyOrderIndex;